import React, { useState } from "react";

const Listv1 = ({ setShowModal }) => {
  const [list, setList] = useState(0);

  const agendaList = [
    [
      {
        time: "10am - 6pm",
        location: "SLC Walkway",
        title: "Quack Quarters",
        desc: <>
          Join us for a day of Duckie-themed excitement! When you RSVP, don't forget to claim your adorable Cochet Duckie Keychain at our gift redemption counter. Dive into the 'Hook-A-Duck' activity to test your skills and win even more Duckie merchandise! And for a sweet treat, be sure to stop by the Inside Scoop booth for some delicious ice cream. Plus, be sure to capture the moment at our dedicated Duckie photobooth! Sign up{" "}
          {/* eslint-disable-next-line */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowModal(true)
            }}
            className="ticket-here"
          >
            here
          </a>
          {' '}to redeem exclusive duckie merchandise!
        </>
      },
      {
        time: "12pm - 8pm",
        location: "SLC Walkway",
        title: "Booth Activities",
        desc: "Capture moments at @mewmovement's photo booth, glam up with @saltyeeth bling, enjoy floral art at the Flower Bar, and sip special mocktails by Booze and Fuse. "
      },
      {
        time: "12pm - 8pm",
        location: "SLC Walkway",
        title: "Scavenger Hunt",
        desc: "Participants will receive a list of items to find or tasks to complete within a 15-minute time limit. If participants successfully check off everything on the list before the time runs out, they will be eligible for rewards, including a free concert ticket and more."
      },
      {
        time: "12pm - 8pm",
        location: "SLC Walkway",
        title: "Food & Vendors",
        desc: "Delight your taste buds with a variety of delectable treats from our food vendors on event day! And for all you coffee and Milo lovers, we've got you covered with Nescafe and Milo drink trucks ready to serve up your favourites. Come hungry and thirsty! "
      },
      {
        time: "12pm - 8pm",
        location: "Uni Square",
        title: "Picnic",
        desc: "Relax and unwind at our inviting picnic zone, where good food meets great company. Grab a cozy spot, savour delicious bites from our food vendors, and enjoy the perfect backdrop for bonding with friends and family."
      },
      {
        time: "3pm - 630pm",
        location: "Architecture Amphitheatre",
        title: "Secondary Stage Performances",
        desc: "Enjoy captivating performances by a lineup of talented individuals from the  Taylor's Music Club Performing Team!"
      },
      {
        time: "630pm - 830pm",
        location: "Architecture Amphitheatre",
        title: "Outdoor Jam Sessions",
        desc: "Ready for some musical magic?  Join our outdoor jam! Musicians from all walks of life, grab your instrument, pick a song from our list of 25, sign up right at the amphitheater, and let the music flow. Everyone's invited! "
      }
    ],
    [
      {
        time: "10am - 6pm",
        location: "SLC Walkway",
        title: "Quack Quarters",
        desc: <>
          Join us for a day of Duckie-themed excitement! When you RSVP, don't forget to claim your adorable Cochet Duckie Keychain at our gift redemption counter. Dive into the 'Hook-A-Duck' activity to test your skills and win even more Duckie merchandise! And for a sweet treat, be sure to stop by the Inside Scoop booth for some delicious ice cream. Plus, be sure to capture the moment at our dedicated Duckie photobooth! Sign up{" "}
          {/* eslint-disable-next-line */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowModal(true)
            }}
            className="ticket-here"
          >
            here
          </a>
          {' '}to redeem exclusive duckie merchandise!
        </>
      },
      {
        time: "12pm - 8pm",
        location: "SLC Walkway",
        title: "Booth Activities",
        desc: "Experience an unforgettable event day with a world of entertainment! Pose for the camera at the @mewmovement Photo Booth, bedazzle yourself with bling from @saltyeeth, unleash your creativity at the Flower Bar, embrace artistic henna designs, snag cool swag at Gift Redemption, craft your custom T-shirt with Taylor’s Art Club's DIY station, savour special mocktails from Booze and Fuse, and let loose on the dance floor in the electrifying Dance Cypher Sessions hosted by TLDC. "
      },
      {
        time: "12pm - 8pm",
        location: "SLC Walkway",
        title: "Scavenger Hunt",
        desc: "Participants will receive a list of items to find or tasks to complete within a 15-minute time limit. If participants successfully check off everything on the list before the time runs out, they will be eligible for rewards, including a free concert ticket and more."
      },
      {
        time: "12pm - 8pm",
        location: "SLC Walkway",
        title: "Food & Vendors",
        desc: "Delight your taste buds with a variety of delectable treats from our food vendors on event day! And for all you coffee and Milo lovers, we've got you covered with Nescafe and Milo drink trucks ready to serve up your favourites. Come hungry and thirsty! "
      },
      {
        time: "12pm - 8pm",
        location: "Uni Square",
        title: "Picnic",
        desc: "Relax and unwind at our inviting picnic zone, where good food meets great company. Grab a cozy spot, savour delicious bites from our food vendors, and enjoy the perfect backdrop for bonding with friends and family."
      },
      {
        time: "12pm - 330pm",
        location: "Architecture Amphitheatre (Secondary Stage)",
        title: "Secondary Stage Performances",
        desc: "Enjoy captivating performances by a lineup of talented groups, including Taylor's Music Club Performing Team, L.I.V.E Club, the mesmerizing 24 Festive Drums, and the soul-stirring sounds of The Heartstrings."
      },
      {
        time: "330pm - 5pm",
        location: "Architecture Amphitheatre (Secondary Stage)",
        title: "Dance Cypher Session",
        desc: <>
          Cypher sessions: Dance freely, connect deeply. Unleash creativity, gain confidence, and form bonds in the dance circle. Express and connect through movement! Sign up for a spot{" "}
          {/* eslint-disable-next-line */}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSd0J-mRIWX3F5eAuFyaWF8yM9Z_3CakYFhcnjFlDelWHdUs3Q/viewform"
            target="_blank"
            rel="noreferrer"
            className="ticket-here"
          >
            here
          </a>.
        </>
      },
      {
        time: "5pm - 815pm",
        location: "The Grand Hall (Main Stage)",
        title: "Main Concert",
        desc: `Catch your favourite artists performing for TMC ‘More Than Just Music’ Event!
          6pm - Opening Act by TMC & TSO
          630pm - JAIE
          7pm - RESORT
          730pm - Midnight Fusic
        `
      }
    ]
  ];

  const dates = [
    { day: 'Fri, 29th September', time: '10am - 10pm' },
    { day: 'Sat, 30th September', time: '10am - 9pm' },
  ]

  return (
    <>
      <div className="w-full flex mb-9 items-center">
        {dates.map((item, index) => (
          <>
            <div className={`p-5 cursor-pointer ${index === list ? 'underline' : ''}`} key={index} onClick={() => setList(index)}>
              <p className="font-black text-2xl" style={{ color: "#FEE600" }}>{item.day}</p>
              <p className="text-base font-normal">{item.time}</p>
            </div>
            {index !== dates.length - 1 && (
              <div className="w-0.5 flex items-center" style={{ alignSelf: 'stretch' }}>
                <div className="w-full h-1/2 bg-gray-300" />
              </div>
            )}
          </>
        ))}
      </div>
      {list === 1 && (
        <p className="text-base font-normal italic">For TMC MTJM Ticket Holders Only</p>
      )}
      {agendaList[list].map((item, index) => (
        <div
          key={index}
          className="w-full flex flex-col space-y-4 md:flex-row md:space-x-0 md:space-y-0 relative agenda column-parent-agenda"
        >
          <div className="w-2/5 lg:w-1/4 relative column-time registration-desc">
            <p>{item.time}</p>
            <br />
          </div>
          <div className="w-3/5 lg:w-3/4 column-desc">
            <div className="pr-7 width-agenda content-aside-container">
              <h1 className="text-2xl md:text-4xl mb-0 title registration-title">
                {item.title}
              </h1>
              <i>{item.location}</i>
              <p
                className="text-lg registration-desc font-thin mt-2"
                style={{ whiteSpace: "pre-line" }}
              >
                {Array.isArray(item.desc) ? (
                  <ul>
                    {item.desc.map((desc, index) => (
                      <li key={index}>
                        - {desc.includes("https") ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={desc.split("(")[1].split(')')[0]}
                          >
                            {desc.split("(")[0]}
                          </a>
                        ) : desc
                        }
                      </li>
                    ))}
                  </ul>
                ) : item.desc
                }
              </p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Listv1;
